import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Proof And Badges",
  fields: {
    ...ThemeConfig,
    proofsSection: {
      type: FIELD_TYPES.NESTED,
      label: "Proofs Section",
      fields: {
        backgroundImage: {
          type: FIELD_TYPES.GALLERY,
          label: "Background Image"
        },
        proofs: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Proofs",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: { ...FullParagraphFieldsConfig, ...FullParagraphAdvancedFieldsConfig }
          }
        }
      }
    },
    badgesSection: {
      type: FIELD_TYPES.NESTED,
      label: "Badges Section",
      fields: {
        badgesSections: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Badges Sections",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              icon: {
                type: FIELD_TYPES.GALLERY,
                label: "Icon"
              },
              title: {
                type: FIELD_TYPES.TEXT,
                label: "Title"
              },
              description: {
                type: FIELD_TYPES.TEXT,
                label: "Description"
              },
              badges: {
                type: FIELD_TYPES.MULTIPLE_NESTED,
                label: "Badges",
                nestedConfig: {
                  type: FIELD_TYPES.NESTED,
                  fields: {
                    badgeImage: {
                      type: FIELD_TYPES.GALLERY,
                      label: "Badge"
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
